module.exports = __webpack_public_path__ + "img/marinade.2b8dd2f5.svg";